module.exports = __webpack_public_path__ + "static/media/Airplane_main_preview.8ae24ee7.jpg";